export const PAYMENT_STEPS = {
    BILL_DETAILS: "BillDetails",
    PAYMENT_SUCESS: "PaymentSuccess",
    ADD_FUNDS: "AddFunds",
    ADD_FUNDS_BY_CARD: "AddFundsByCard",
    ADD_FUNDS_PREPAY: "AddFundsPrepay",
}

export const PAYMENT_DRAWER_LOADING_STATES = {
    APPLY_COUPON_LOADING: "APPLY_COUPON_LOADING",
    APPLY_COUPON_READY: "APPLY_COUPON_READY",
    BILL_DETAILS_DRAWER_LOADING: "BILL_DETAILS_DRAWER_LOADING",
    BILL_DETAILS_DRAWER_READY: "BILL_DETAILS_DRAWER_READY",
    CALCULATE_PREPAY_SALES_TAX_LOADING: "CALCULATE_PREPAY_SALES_TAX_LOADING",
    CALCULATE_PREPAY_SALES_TAX_READY: "CALCULATE_PREPAY_SALES_TAX_READY",
    GET_PREPAY_AMOUNT_LOADING: "GET_PREPAY_AMOUNT_LOADING",
    GET_PREPAY_AMOUNT_READY: "GET_PREPAY_AMOUNT_READY",
    ADD_PREPAY_BALANCE_LOADING: "ADD_PREPAY_BALANCE_LOADING",
    ADD_PREPAY_BALANCE_READY: "ADD_PREPAY_BALANCE_READY",
    PAY_NOW_LOADING: "PAY_NOW_LOADING",
    PAY_NOW_READY: "PAY_NOW_READY",
    GET_SAVED_CARDS_LOADING: "GET_SAVED_CARDS_LOADING",
    GET_SAVED_CARDS_READY: "GET_SAVED_CARDS_READY",
    STRIPE_SAVED_CARDS_SALES_TAX_LOADING: "STRIPE_SAVED_CARDS_SALES_TAX_LOADING",
    STRIPE_SAVED_CARDS_SALES_TAX_READY: "STRIPE_SAVED_CARDS_SALES_TAX_READY",
    VALIDATING_ZIP_CODE_LOADING: "VALIDATING_ZIP_CODE_LOADING",
    VALIDATING_ZIP_CODE_READY: "VALIDATING_ZIP_CODE_READY",
    PAYMENT_BY_NEW_CARD_LOADING: "PAYMENT_BY_NEW_CARD_LOADING",
    PAYMENT_BY_NEW_CARD_READY: "PAYMENT_BY_NEW_CARD_READY",
}

export const PAYMENT_DRAWER_MESSAGE_MAP = {
    [PAYMENT_DRAWER_LOADING_STATES.PAY_NOW_LOADING]: "Loading",
    [PAYMENT_DRAWER_LOADING_STATES.GET_SAVED_CARDS_LOADING]: "fetching card details",
    [PAYMENT_DRAWER_LOADING_STATES.ADD_PREPAY_BALANCE_LOADING]: "adding balance",
    [PAYMENT_DRAWER_LOADING_STATES.STRIPE_SAVED_CARDS_SALES_TAX_LOADING]: "calculating sales tax",
    [PAYMENT_DRAWER_LOADING_STATES.APPLY_COUPON_LOADING]: "applying coupon",
    [PAYMENT_DRAWER_LOADING_STATES.VALIDATING_ZIP_CODE_LOADING]: "validating zip",
    [PAYMENT_DRAWER_LOADING_STATES.PAYMENT_BY_NEW_CARD_LOADING]: "",
}

export const PAYMENT_MODES = {
    ADD_NEW_CARD: "AddNewCard",
    PAY_USING_SELECTED_CARD: "PayUsingSelectedCard",
    PAY_BY_ENTERING_CARD_DETAILS: "PayByEnteringCardDetails"
}

export const PAYMENT_OPTIONS = [
    { label: "Pay using saved cards", value: PAYMENT_MODES.PAY_USING_SELECTED_CARD },
    { label: "Pay using new card", value: PAYMENT_MODES.PAY_BY_ENTERING_CARD_DETAILS },
]

export const PAYMENT_BY_CARD_TYPE_OPTIONS = [
    {label: "Pay via card + prepay", value: "card+prepay"},
    {label: "Pay via card only", value: "onlyCard"},
]

export const PLACE_OF_ORIGIN_FOR_PAYMENT = {
    SUBMIT_FORM_PAGE: "Submitformpage",
    PDF_PAYMENT: "PdfPayment",
    USPS_PAYMENT: "USPSPayment",
    MR_W8_W9_PAYMENT: "MRW8W9Payment",
    TIN_PAYMENT: "TinPayment",
    RECONCILIATION_PAYMENT: "RecPayment",
    SINGLE_TIN_PAYMENT: "SingleTinPayment",
    BULK_TIN_PAYMENT: "BulkTinPayment",
    BULK_W8_W9_PAYMENT: "BulkW8W9Payment",
    SINGLE_W8_W9_PAYMENT: "SingleW8W9Payment",
    SF_PAYMENT: "SFPayment",
    CHANGE_PLAN: "Userpurchaseplan",
    BULK_CONSENT_PAYMENT: "BulkConsentPayment",
    NOTICE_MANAGEMENT: "Noticemgt",
    W8W9_REQUEST: 'W8W9requesthistory',
    BOI_FORM_PAYMENT: 'BoiFormPayment',
}

export const PRICING = {
    STATE_FILING: 0.25,
    USPS_MAIL_TO_RECIPIENT: 1.80,
    E_DELIVERY: 0.25,
}

export const MINIMUM_PREPAY_THRESHOLD = 0.50;

export const SHOW_COUPON_CODE_OPTION_FOR = [PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE, PLACE_OF_ORIGIN_FOR_PAYMENT.BOI_FORM_PAYMENT]
